import axios from '@/api/axios.config'
import { api } from '@/utils/global/api'

/**
 * The absolute address of a backend path, read against the API base URL
 * (`…/v1/`): the backend serves its docs at its root, beside `/v1`.
 */
export const backendAddress = (path: string, apiBase: string = api) =>
  new URL(path, apiBase).toString()

/**
 * Asks the backend for a one-time ticket into its API docs and answers the
 * address that redeems it, which signs the browser in to `/docs` for the
 * session. Super admins only.
 */
export const requestApiDocsAddress = async () => {
  const { data } = await axios.post<{ path: string }>('admin/api-docs/ticket')
  return backendAddress(data.path)
}
